<div class="p-6">
  <ng-container *ngIf="status === 'not-installed'">
    <h2 class="text-lg font-bold mb-3">{{translate.getTranslation('quickEntryNotInstalledTitle')}}</h2>
    <p class="text-sm mb-6">{{translate.getTranslation('quickEntryNotInstalledBody')}}</p>
    <div class="flex flex-row justify-between items-center">
      <button *ngIf="suppressesGlobalNag" class="text-sm text-gray hover:no-underline" (click)="dismissForever()">
        {{translate.getTranslation('quickEntryDontRemindAgain')}}
      </button>
      <div class="flex flex-row gap-3">
        <button class="btn btn-grayDark-outline" (click)="close()">{{translate.getTranslation('quickEntryClose')}}</button>
        <button class="btn btn-primary" (click)="goToConfigPage()">
          {{translate.getTranslation('quickEntryGoToConfig')}}
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="status === 'installed-logged-out'">
    <h2 class="text-lg font-bold mb-3">{{translate.getTranslation('quickEntryLoggedOutTitle')}}</h2>
    <p class="text-sm mb-6">{{translate.getTranslation('quickEntryLoggedOutBody')}}</p>
    <div class="flex flex-row justify-end gap-3">
      <button class="btn btn-grayDark-outline" (click)="close()">{{translate.getTranslation('quickEntryClose')}}</button>
      <button class="btn btn-grayDark-outline" (click)="goToConfigPage()">
        {{translate.getTranslation('quickEntryGoToConfig')}}
      </button>
      <button class="btn btn-primary" [disabled]="isLoggingIn" (click)="login()">
        {{translate.getTranslation('quickEntryLogin')}}
      </button>
    </div>
  </ng-container>
</div>
